import { IFreeGamesVendorData } from '../../../../vendor_core/src/model/IFreeGamesVendorData';
import { IVendorData } from '../../../../vendor_core/src/model/IVendorData';
import VendorDataParser from "../../../../vendor_core/src/server/parsers/VendorDataParser";

// TODO remove or add relevant data

export default class CRCVendorDataParser extends VendorDataParser {
    check(data: any): boolean {
        return data && !data.errorCode && data?.stats?.freespins;
    }

    parse(data): IVendorData {

        let result;
        const freeGames: IFreeGamesVendorData = data.stats.freespins;
        if (freeGames && freeGames["la"] && freeGames["l"]) {
            freeGames.ba = freeGames["la"] * freeGames["l"];
        }
        if (freeGames.betSizeOptions) {
            freeGames.betSizeOptions.forEach(d => {
                d.ba = d["la"] * d["l"];
            })
        }
        result = {
            grids: data.config?.grids,
            freeGames: freeGames
        };

        return result;
    }



}
